// Takes a date string and formats it in a more readable way
function PrettifyDate(date, omitYear) {

  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]

  const dateArray = date.split("-");
  const day = parseInt(dateArray[2]);
  const month = months[parseInt(dateArray[1]) - 1];
  const year = dateArray[0];

  var suffix;
  if(day >= 4 && day <= 20) { suffix = 'th' }
  else if (day % 10 === 1)  { suffix = 'st' }
  else if (day % 10 === 2)  { suffix = 'nd' }
  else if (day % 10 === 3)  { suffix = 'rd' }
  else                      { suffix = 'th' }

  const options = { weekday: 'short' }
  const fullDate = new Date(date);
  const currentWeekday = fullDate.toLocaleString('en-US', options);

  const result = currentWeekday + ', ' + day + suffix + ' ' + month + (omitYear? '' : (' ' + year))

  return result;
}

export default PrettifyDate;